__webpack_require__.p = "/NotesAI/";